/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_New_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "New KNP Guide" |
*
* @param {Knp_Manager_New_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_new_guide_title = /** @type {((inputs?: Knp_Manager_New_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_New_Guide_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau guide KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer KNP-Führer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova guida KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый путеводитель по КНП")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva guía del KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新克鲁格国家公园指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいKNPガイド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई केएनपी गाइड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo guia do Parque Nacional Kruger")
	return /** @type {LocalizedString} */ ("New KNP Guide")
});